import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Button } from 'primereact/button';

import { firmasConformeSchema } from '../../validation/firmas-conforme';
import SignaturePad from '../../components/firma-pad/signature-pad';

import './firmas-conforme.css'


function FirmasConforme({ revisionId, onFinalizar, onVolver, valoresIniciales, soloLectura }) {
  const [enviando, setEnviando] = useState(false);
  const firmaCliente = valoresIniciales?.firmas?.find((f) => f.tipo_firma === 'cliente');
  const firmaTecnico = valoresIniciales?.firmas?.find((f) => f.tipo_firma === 'tecnico');

  const {
    control,
    handleSubmit, getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(firmasConformeSchema),
    mode: 'onTouched',
    defaultValues: {
      // cliente
      firmaClienteNombre: firmaCliente?.nombre_firmante ?? '',
      firmaClienteRut: firmaCliente?.rut_firmante ?? '',
      firmaClienteImagen: firmaCliente?.ruta_imagen ?? null,
      // tecnico
      firmaTecnicoNombre: firmaTecnico?.nombre_firmante ?? '',
      firmaTecnicoRut: firmaTecnico?.rut_firmante ?? '',
      firmaTecnicoImagen: firmaTecnico?.ruta_imagen ?? null,
    },
  });

  const onSubmit = async (data) => {
    setEnviando(true);
    try {
      const payload = {
        firmaCliente: data.firmaClienteImagen,
        firmaTecnico: data.firmaTecnicoImagen,
        firmasCompletas: true,
      };
      await onFinalizar?.(payload);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <section className="tmc-form mt-3 mb-6">
      <form 
        className="container-form"
        onSubmit={handleSubmit(onSubmit)} 
        noValidate
      >
        {/* ---------------- Terminos y condiciones ---------------- */}
        <div className='card-nc'>
          <p className="text-center">Términos y Condiciones</p>
          <div className="text-muted pr-4" style={{ textAlign: 'justify' }}>
            <small>
              <ol className='mb-0 ml-3'>
                <li>El taller mecánico no se hace responsable por pérdidas o daños de objetos de valor que permanezcan dentro del vehículo durante su permanencia en las instalaciones.</li>
                <li>El taller mecánico no se hace responsable por daños o fallas que el vehículo ya tuviera antes de ingresar. Estos se dejarán registrados en el informe de recepción.</li>
                <li>Al firmar este documento, el cliente declara haber leído, comprendido y aceptado los presentes términos y condiciones.</li>
              </ol>
            </small>
          </div>
        </div>  

        {/* ---------------- Firma cliente ---------------- */}
        <div className="card-nc">
          <h5 className="mb-3">I. Firma del cliente</h5>

          <div className="mb-2 mt-2">
            <Controller
              name="firmaClienteImagen"
              control={control}
              render={({ field }) => (
                <SignaturePad
                  label="Rehacer firma"
                  value={field.value}
                  onChange={field.onChange}
                  error={errors.firmaClienteImagen?.message}
                />
              )}
            />
          </div>
          <div className="firma-info">
            <p className="nombre">{getValues('firmaClienteNombre')}</p>
            <p className="rut">{getValues('firmaClienteRut')}</p>
          </div>
        </div>

        {/* ---------------- Firma técnico ---------------- */}
        <div className="card-nc">
          <h5 className="mb-3">II. Firma del técnico</h5>

          <div className="mb-2 mt-2">
            <Controller
              name="firmaTecnicoImagen"
              control={control}
              render={({ field }) => (
                <SignaturePad
                  label="Rehacer firma"
                  value={field.value}
                  onChange={field.onChange}
                  error={errors.firmaTecnicoImagen?.message}
                />
              )}
            />
          </div>
          <div className="firma-info">
            <p className="nombre">{getValues('firmaTecnicoNombre')}</p>
            <p className="rut">{getValues('firmaTecnicoRut')}</p>
          </div>
        </div>

        {/* ---------------- Acciones ---------------- */}
        <div className="d-flex justify-content-between mt-3">
          <Button
            type="button"
            label="Paso anterior"
            icon="pi pi-arrow-left"
            className="btn-raised-azul"
            onClick={onVolver}
            disabled={enviando}
          />
          <Button
            type="submit"
            label="Finalizar firmas"
            icon="pi pi-check-circle"
            className='btn-lleno-verde'
            loading={enviando}
            disabled={enviando || !revisionId}
          />
        </div>
      </form>
    </section>
  );
}

export default FirmasConforme;
